export default __webpack_public_path__ + "static/media/jewellery.2566fe82.jpeg";